export const GRID_SPACING = '10px';
export const MOBILE_DATA_GRID_COLUMN = 'mobile-data-grid-column';